<template>
  <div class="popUpWrap dark">
    <section class="popup dark trackInfo">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="trackIcon" :class="trackTypeClass"></div>
        <div class="textArea flex">
          <h5>{{ getTrackData.trackTitle }}</h5>
          <pre v-html="getTrackData.description"></pre>
        </div>
        <ul class="categoryArea">
          <li><svg xmlns="http://www.w3.org/2000/svg" width="14" height="6" viewBox="0 0 14 6" fill="none">
            <path d="M10.0647 0.701448L12.3662 2.99995L10.0647 5.29845" stroke="#9098AA" stroke-linecap="round"></path>
            <path d="M7.76622 0.699951L6.23389 5.29696" stroke="#9098AA" stroke-linecap="round"></path>
            <path d="M3.93533 0.701448L1.63384 2.99995L3.93533 5.29845" stroke="#9098AA" stroke-linecap="round"></path>
          </svg></li>
          <li
            v-for="(category, index) in getTrackData.categories.slice(0, 3)"
            :key="index"
          >
            {{ category }}
          </li>
          <li
            v-if="moreCategories.length > 0"
            class="over"
            :class="{ on: isMoreCategoryPopup }"
          >
          <span @click.stop="toggleMoreCategoryPopup">
            <span>+{{ moreCategories.length }}</span>
          </span>
            <ul class="list">
              <li
                v-for="(moreCategory, moreIndex) in moreCategories"
                :key="moreIndex"
              >
                {{ moreCategory }}
              </li>
            </ul>
          </li>
        </ul>
        <!-- TODO: SkillAdvance 잠정 비활성화 -->
<!--        <a class="link" @click.stop="onClickShiftTrackDetail"><span class="icon"></span>{{ t('advance-more-track') }}</a>-->
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {computed, useRouter} from '#imports';
import {useDialogStore} from '~/store/dialog/dialogStore';
import {useI18n} from 'vue-i18n';
import {TrackType} from '~~/package/mapper/track/model/TrackType';

const {t} = useI18n()

const dialogStore = useDialogStore();
const router = useRouter();

const isMoreCategoryPopup = ref(false);

const getTrackData = computed(() => {
  return dialogStore.options.props.track
})

const trackTypeClass = computed(() =>
    (dialogStore.options.props.track.trackType as string).toLowerCase()
);

const moreCategories = computed(() => getTrackData.value.categories.slice(3));

const toggleMoreCategoryPopup = () => {
  isMoreCategoryPopup.value = !isMoreCategoryPopup.value;
};

const onClickShiftTrackDetail = () => {
  const trackDetailRouteData = router.resolve({
    name: "dashboard-skillAdvance-practice-practiceId",
    params: { practiceId: dialogStore.options.props.track.trackId }
  });
  window.open(trackDetailRouteData.href, "_blank");
};

const onClickClose = () => {
    dialogStore.close();
};
</script>

